module.exports = __webpack_public_path__ + "img/Group_10.b9e86c36.png";